import { storeToRefs } from 'pinia';
import { useGoogleReserveStore } from '@/stores/google-reserve';
import { useTreatwellStore } from '@/stores/treatwell';
import { useUserStore } from '@/stores/user';
import unleash from '@/unleash';
import treatwell from './treatwell';

const Online = () => import('@/modules/online/index.vue');
const OnlineWebsiteService = () =>
  import('@/modules/online/website-service/index.vue');
const OnlineGoogleReserve = () =>
  import('@/modules/online/google-reserve/index.vue');
const OnlineBookingWidget = () =>
  import('@/modules/online/booking-widget/index.vue');

export default {
  path: 'online',
  name: 'online',
  component: Online,
  meta: {
    moduleName: 'online',
  },
  redirect: () => {
    const { showTreatwell } = useTreatwellStore();
    const { hasFeatureFlag } = useUserStore();
    const websiteServiceEnabled = unleash.isEnabled('WebsiteService');
    const { showIntegration: showGoogleReserve } = storeToRefs(
      useGoogleReserveStore(),
    );

    if (showTreatwell && hasFeatureFlag('treatwell-brand')) {
      return {
        name: 'treatwell-landing',
      };
    }

    if (hasFeatureFlag('module-appointments')) {
      return {
        name: 'online-booking-widget',
      };
    }

    if (showTreatwell) {
      return {
        name: 'treatwell-landing',
      };
    }

    if (websiteServiceEnabled) {
      return {
        name: 'online-website-service',
      };
    }

    if (showGoogleReserve.value) {
      return {
        name: 'online-google-reserve',
      };
    }

    return {
      name: 'dashboard',
    };
  },
  children: [
    {
      path: 'website-service',
      name: 'online-website-service',
      component: OnlineWebsiteService,
      meta: {
        unleash: 'WebsiteService',
      },
    },
    ...treatwell,
    {
      path: 'google-reserve',
      name: 'online-google-reserve',
      component: OnlineGoogleReserve,
      meta: {
        featureFlag: 'module-google-reserve',
      },
    },
    {
      path: 'booking-widget',
      name: 'online-booking-widget',
      component: OnlineBookingWidget,
      meta: {
        featureFlag: 'module-appointments',
      },
    },
  ],
};
